import React from "react";
import { useNavigate } from "react-router-dom";

import { BsArrowRightShort } from "react-icons/bs";

const tableHead = [
  "Sr",
  "type",
  "factor (key)",
  "unit",
  "description",
  // "0-100",
  // "101-200",
  // "201-400",
  // "401-500",
  // "501-1000",
  // "1001-1500",
  // "1501-2000",
  // "2001-2500",
  // "2501-3000",
  // "3001-3500",
  // "3501-4000",
  // "4001-4500",
  // "4501-5000",
  // "5001-5500",
  // "5501-6000",
  // "6001-6500",
  // "6501-7000",
  // "7001-7500",
  // "7501-8000",
  // "8000+",
  // "Weedmat",
  // "markup 0-100",
  // "markup 101-200",
  // "markup 201-400",
  // "markup 401-500",
  // "markup 501-1000",
  // "markup 1001-1500",
  // "markup 1501-2000",
  // "markup 2001-2500",
  // "markup 2501-3000",
  // "markup 3001-3500",
  // "markup 3501-4000",
  // "markup 4001-4500",
  // "markup 4501-5000",
  // "markup 5001-5500",
  // "markup 5501-6000",
  // "markup 6001-6500",
  // "markup 6501-7000",
  // "markup 7001-7500",
  // "markup 7501-8000",
  // "markup 8000+",
  "Actions",
];

const QutationMatrixTable = ({ data }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/standard-quotation/view/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            return (
              <tr key={item?.id}>
                <td>{++index}</td>
                <td>{item?.type}</td>
                <td>{item?.factor}</td>
                <td>{item?.unit}</td>
                <td>{item?.description}</td>
                {/* <td>{item?.basePrice0To100}</td>
                <td>{item?.basePrice101To200}</td>
                <td>{item?.basePrice201To400}</td>
                <td>{item?.basePrice401To500}</td>
                <td>{item?.basePrice501To1000}</td>
                <td>{item?.basePrice1001To1500}</td>
                <td>{item?.basePrice1501To2000}</td>
                <td>{item?.basePrice2001To2500}</td>
                <td>{item?.basePrice2501To3000}</td>
                <td>{item?.basePrice3001To3500}</td>
                <td>{item?.basePrice3501To4000}</td>
                <td>{item?.basePrice4001To4500}</td>
                <td>{item?.basePrice4501To5000}</td>
                <td>{item?.basePrice5001To5500}</td>
                <td>{item?.basePrice5501To6000}</td>
                <td>{item?.basePrice6001To6500}</td>
                <td>{item?.basePrice6501To7000}</td>
                <td>{item?.basePrice7001To7500}</td>
                <td>{item?.basePrice7501To8000}</td>
                <td>{item?.basePriceGreater8000}</td>
                <td>{item?.sqMtrWeed}</td>
                <td>{item?.markupPercent0To100}</td>
                <td>{item?.markupPercent101To200}</td>
                <td>{item?.markupPercent201To400}</td>
                <td>{item?.markupPercent401To500}</td>
                <td>{item?.markupPercent501To1000}</td>
                <td>{item?.markupPercent1001To1500}</td>
                <td>{item?.markupPercent1501To2000}</td>
                <td>{item?.markupPercent2001To2500}</td>
                <td>{item?.markupPercent2501To3000}</td>
                <td>{item?.markupPercent3001To3500}</td>
                <td>{item?.markupPercent3501To4000}</td>
                <td>{item?.markupPercent4001To4500}</td>
                <td>{item?.markupPercent4501To5000}</td> */}
                {/* <td>{item?.markupPercent5001To5500}</td>
                <td>{item?.markupPercent5501To6000}</td>
                <td>{item?.markupPercent6001To6500}</td>
                <td>{item?.markupPercent6501To7000}</td>
                <td>{item?.markupPercent7001To7500}</td>
                <td>{item?.markupPercent7501To8000}</td>
                <td>{item?.markupPercentGreater8000}</td> */}

                <td>
                  <button
                    className="btn btn-primary btn-sm  px-3"
                    onClick={() => goToView(item?.id)}
                  >
                    <BsArrowRightShort className="me-1" /> View
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default QutationMatrixTable;
